
let initialState = {
    dynamicAPI: ''
};

const DynamicReducer = (state = initialState, action) => {
    return state;
}

export default DynamicReducer;